import * as actionTypes from './_actionTypes';

const initialState = {
  students: [],
  pagination: {
    page: 1,
    limit: 20,
    total: 0,
    total_pages: 0,
  },
  summary: {
    totalStudents: 0,
    studentsWithProgress: 0,
    averageOverallProgress: 0,
    totalTimeSpent: 0,
    averageTimePerStudent: 0,
  },
  filters: {
    collegeId: null,
    courseId: null,
    studentId: null,
    search: '',
    degree: 'all',
    batch: '',
    semester: 'all',
    progressLevel: 'all',
    page: 1,
    limit: 20,
  },
  loading: false,
  exporting: false,
  error: null,
  exportError: null,
};

const adminProgressTrackingReducer = (state = initialState, action) => {
  switch (action.type) {
    case actionTypes.FETCH_STUDENT_PROGRESS_REQUEST:
      return { ...state, loading: true, error: null };

    case actionTypes.FETCH_STUDENT_PROGRESS_SUCCESS:
      return {
        ...state,
        loading: false,
        students: action.payload.students || [],
        pagination: action.payload.pagination || state.pagination,
        summary: action.payload.summary || state.summary,
        error: null,
      };

    case actionTypes.FETCH_STUDENT_PROGRESS_FAILURE:
      return { ...state, loading: false, error: action.payload };

    case actionTypes.EXPORT_PROGRESS_REPORT_REQUEST:
      return { ...state, exporting: true, exportError: null };

    case actionTypes.EXPORT_PROGRESS_REPORT_SUCCESS:
      return { ...state, exporting: false, exportError: null };

    case actionTypes.EXPORT_PROGRESS_REPORT_FAILURE:
      return { ...state, exporting: false, exportError: action.payload };

    case actionTypes.SET_PROGRESS_FILTERS:
      return { ...state, filters: { ...state.filters, ...action.payload } };

    case actionTypes.CLEAR_PROGRESS_FILTERS:
      return {
        ...state,
        filters: {
          ...initialState.filters,
          collegeId: state.filters.collegeId,
        },
      };

    default:
      return state;
  }
};

export default adminProgressTrackingReducer;
